import AnimatedSection from '../common/AnimatedSection'
import { achievementsCommitmentIcons } from '../icons/AchievementsCommitmentIcons'
import LeadershipSectionLabel from '../leadership/LeadershipSectionLabel'
import { achievementsCommitmentSection } from '../../data/achievementsPageData'

const commitmentBg = '/assets/achievements-hero-bg.png'

function AchievementsCommitmentSection() {
  const { label, titleLine1, titleAccent, description, stats } = achievementsCommitmentSection

  return (
    <AnimatedSection className="achievements-commitment">
      <div className="achievements-commitment__bg" aria-hidden="true">
        <img src={commitmentBg} alt="" loading="lazy" />
        <div className="achievements-commitment__overlay" />
      </div>

      <div className="container corp-container achievements-commitment__container">
        <div className="achievements-commitment__grid">
          <div className="achievements-commitment__copy">
            <LeadershipSectionLabel variant="red">{label}</LeadershipSectionLabel>
            <h2>
              {titleLine1} <span>{titleAccent}</span>
            </h2>
            <p>{description}</p>
            <span className="achievements-commitment__accent" aria-hidden="true" />
          </div>

          <div className="achievements-commitment__stats" role="list">
            {stats.map((stat) => {
              const Icon = achievementsCommitmentIcons[stat.icon]
              return (
                <article className="achievements-commitment__stat" key={stat.id} role="listitem">
                  <span className="achievements-commitment__stat-icon" aria-hidden="true">
                    <Icon />
                  </span>
                  <p className="achievements-commitment__stat-value">
                    {stat.value}
                    <span>{stat.suffix}</span>
                  </p>
                  <h3>{stat.title}</h3>
                  <p className="achievements-commitment__stat-sub">{stat.subtitle}</p>
                </article>
              )
            })}
          </div>
        </div>
      </div>
    </AnimatedSection>
  )
}

export default AchievementsCommitmentSection
